import React from "react"

export default () => (
  <div class="container">
    <img src="/bison.svg" alt="Bison" />
    <h1>Bodhi Hudson</h1>
    <em>29 oktober 2019</em>
  </div>
)
